module.exports = __webpack_public_path__ + "static/media/panji-1.ef6d1126.jpg";